export const BaseTemplate = {
  pages: [
    {
      name: "page1",
      elements: [
        {
          type: "html",
          name: "content",
          html: `
            <div >
              <p style="font-size: 14px; font-weight: 500; line-height: 16px; text-align: left; color: red;">
                edit_personal_information_tips
              </p>
            </div>
          `,
        },
        {
          type: "text",
          name: "firstname",
          title: "First Name in English",
          isRequired: true,
          placeholder: "Common.please_enter",
          requiredErrorText: "Common.this_field_is_mandatory",
        },
        {
          type: "text",
          name: "lastname",
          title: "Last Name in English",
          isRequired: true,
          placeholder: "Common.please_enter",
          requiredErrorText: "Common.this_field_is_mandatory",
        },
        {
          type: "text",
          name: "localName",
          isRequired: "true", // PHKL Custom
          title: "Name in Chinese",
          requiredErrorText: "Common.this_field_is_mandatory", // PHKL Custom
        },
        // PHKL Custom s
        {
          name: "noChineseName",
          title: "No Chinese Name",
          titleLocation: "left",
          type: "boolean",
          defaultValue: false,
          fieldType: "Standard",
          labelTrue: "app.select.yes",
          labelFalse: "app.select.no",
          preset: "confirm_checkbox",
        },
        // PHKL Custom e
        {
          type: "paneldynamic",
          name: "regionPhone",
          title: "Mobile Number",
          titleLocation: "top",
          readOnly: false,
          isRequired: true,
          templateElements: [
            {
              type: "dropdown",
              name: "regionCode",
              width: "36%",
              minWidth: "36%",
              maxWidth: "36%",
              readOnly: false,
              startWithNewLine: false,
              allowClear: false,
              title: "Country Code",
              titleLocation: "hidden",
              isRequired: true,
              requiredErrorText: "Please select option where applicable",
              fieldType: "Standard",
              choices: ["+852", "+853", "+62"],
              modalConfig: {
                modalTitle: "Common.international_country_codes",
                showSearch: true,
              },
            },
            {
              type: "text",
              name: "phoneNumber",
              readOnly: false,
              width: "64%",
              minWidth: "64%",
              maxWidth: "64%",
              startWithNewLine: false,
              titleLocation: "hidden",
              isRequired: true,
              requiredErrorText: "Common.this_field_is_mandatory",
              validators: [
                {
                  type: "expression",
                  text: "Recruitment.invalid_phone_number",
                  expression:
                    "regionPhoneValidate({#regionPhone[0].regionCode},{regionPhone[0].phoneNumber})",
                },
              ],
              inputType: "tel",
            },
          ],
          allowAddPanel: false,
          allowRemovePanel: false,
          panelCount: 1,
          minPanelCount: 1,
          maxPanelCount: 1,
        },
        {
          type: "text",
          name: "otp",
          title: "Common.verify_code",
          placeholder: "Common.please_enter",
          requiredErrorText: "Common.please_enter",
          textUpdateMode: "onTyping",
          visibleIf: "{isNew} = false && {regionPhone[0].phoneNumber.length} > 0",
          otpConfig: {
            position: "end",
            disabled: false,
            actionParams: {
              context: "FirstLogin",
              lang: "en",
              userType: "CANDIDATE",
              deliveryMethod: "SMS",
            },
          },
        },
        {
          type: "text",
          name: "otp",
          title: "Common.verify_code",
          placeholder: "Common.please_enter",
          requiredErrorText: "Common.please_enter",
          textUpdateMode: "onTyping",
          visibleIf: "{isNew} = false && {regionPhone[0].phoneNumber.length} = 0",
          otpConfig: {
            position: "end",
            disabled: true,
            actionParams: {
              context: "FirstLogin",
              lang: "en",
              userType: "CANDIDATE",
              deliveryMethod: "SMS",
            },
          },
        },
        {
          type: "text",
          name: "yourRecruitingAgent",
          title: "Common.your_recruiting_agent",
          readOnly: true,
          multiline: true,
        },
        {
          type: "boolean",
          name: "privacyPolicyAgreement",
          title: "personal_info_collection_statement_public_portal",
          titleLocation: "left",
          requiredErrorText: "Common.you_must_agree_to_the_privacy_agreement",
          validators: [
            {
              type: "expression",
              text: "Common.you_must_agree_to_the_privacy_agreement",
              expression: "{privacyPolicyAgreement} = true",
            },
          ],
          fieldType: "Standard",
          labelTrue: "Yes",
          labelFalse: "No",
          preset: "confirm_checkcircle",
        },
        {
          type: "html",
          name: "content",
          visibleIf: "{isNew} = true",
          html: `
            <div>
              <p style="font-size: 14px; font-weight: 500; line-height: 16px; text-align: left; color: red;">
                create_personal_information_remark
              </p>
            </div>
          `,
        },
      ],
    },
  ],
  showQuestionNumbers: "off",
};
